import angular from 'angular';

import EventRepeatChangeModalComponent from './event-repeat-change-modal.cmpt';

export default angular
    .module('application.component.modals.component.event-repeat-change-modal', [])
    .component(EventRepeatChangeModalComponent.selector, EventRepeatChangeModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/event-repeat-change-modal/index.js